/**
 * @format
 * @module lib/consts
 */

import tgamConfig from "config/tgam";

/**
 * These URLs ("sec.theglobeandmail" and "sec.stg.theglobeandmail") point to the subscription
 * app's login/session pages and must follow the "?param=value#/fragment" format (as should
 * all URLs, except for those that point to the subscription funnel)
 */
const security = `https://${tgamConfig.env.secDomain}.${tgamConfig.env.wwwDomain}`;

/**
 * These URLs ("subscribe.theglobeandmail" and "stg-subscribe.theglobeandmail") point to
 * the subscription funnel and must follow the "#/fragment?param=value" format (until the
 * Subscription team removes the hash from their app's URLs). This format is invalid,
 * according to the official spec.
 * @see https://tools.ietf.org/html/rfc3986#section-3
 */
const subscribe = `https://${tgamConfig.env.subDomain}.${tgamConfig.env.wwwDomain}`;

const consts = {
  URLS: {
    ACCOUNT: {
      SETTINGS: `${security}/myaccount/account-settings`, // Profile
      // GA_ADVISOR_PROFILE: `${security}/myaccount/advisor-profile-settings`, // Globe Advisor Profile
      SUBSCRIPTIONS: `${security}/myaccount/my-subscription` // My Subscriptions
    },
    LINK_PRINT_ACCOUNT: `${security}/myaccount/find-my-print`,
    LOGIN: `${security}/user/login`,
    LOGOUT: `${security}/user/logout`,
    HELP_CENTRE: "https://globeandmail.force.com/helpcentre/s",
    REGISTER: {
      BASE: `${security}/user/register`,
      REGWALL: `${security}/user/modal/register/regwall`, // responsive page
      CORONA: `${security}/user/modal/register/regwall/covid`, // responsive page
      HOMEPRICE: `${security}/user/modal/register/regwall/homeprice`, // responsive page
      ELECTION: `${security}/user/modal/register/regwall/election`, // responsive page
      CROSSWORDS: `${security}/user/modal/register/regwall/crosswords` // responsive page
    },
    SUBSCRIBE: {
      BASE: subscribe,
      DIGITAL: `${subscribe}/#/digital`,
      EVERGREEN: `${subscribe}/#/product/EVERGREEN`,
      MBSITE: `${subscribe}/#/digital?intcmp=mbsite`
    },
    MODALS: {
      LOGIN: `${security}/user/modal/login`,
      REGISTER: `${security}/user/modal/register`
    }
  },
  // If you change these Keytar limit values, then you also need to:
  // - Update various Jest unit tests
  // - Update various Nightwatch E2E tests
  KEYTAR: {
    REGWALL: {
      LIMIT: 3,
      RENEW: 30
    },
    PAYWALL: {
      LIMIT: 6,
      RENEW: 30
    }
  }
};

export default consts;
